

export class StateOutputData implements IStateOutputData {
    /** The auto-generated id of the state master */
    state_id!: number;
    /** The state name with 255 character limit */
    state_name!: string;
    /** The updated status */
    status!: number;

    constructor(data?: IStateOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state_id = _data["state_id"];
            this.state_name = _data["state_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StateOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new StateOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state_id"] = this.state_id;
        data["state_name"] = this.state_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IStateOutputData {
    /** The auto-generated id of the state master */
    state_id: number;
    /** The state name with 255 character limit */
    state_name: string;
    /** The updated status */
    status: number;
}

